import React, { useState } from 'react';

const SupportWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.message.trim()) return;
    setSending(true);
    try {
      // Send to backend (can wire to SES later)
      await fetch('https://etz8ecs10a.execute-api.ap-southeast-2.amazonaws.com/prod/api/support', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, timestamp: new Date().toISOString() })
      }).catch(() => {});
      setSubmitted(true);
      setTimeout(() => { setSubmitted(false); setIsOpen(false); setForm({ name: '', email: '', message: '' }); }, 3000);
    } catch {} finally {
      setSending(false);
    }
  };

  return (
    <>
      {/* Floating button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          position: 'fixed', bottom: '24px', right: '24px', zIndex: 9999,
          width: '56px', height: '56px', borderRadius: '50%',
          backgroundColor: '#6B9080', border: 'none', cursor: 'pointer',
          boxShadow: '0 4px 16px rgba(107, 144, 128, 0.4)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          transition: 'transform 0.2s, box-shadow 0.2s'
        }}
        onMouseOver={(e) => { e.currentTarget.style.transform = 'scale(1.05)'; e.currentTarget.style.boxShadow = '0 6px 20px rgba(107, 144, 128, 0.5)'; }}
        onMouseOut={(e) => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(107, 144, 128, 0.4)'; }}
      >
        {isOpen ? (
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        ) : (
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
        )}
      </button>

      {/* Form popup */}
      {isOpen && (
        <div style={{
          position: 'fixed', bottom: '92px', right: '24px', zIndex: 9998,
          width: '340px', backgroundColor: 'white', borderRadius: '12px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.15)', overflow: 'hidden',
          animation: 'slideUp 0.2s ease'
        }}>
          <div style={{ backgroundColor: '#6B9080', padding: '16px 20px' }}>
            <h3 style={{ margin: 0, color: 'white', fontSize: '16px', fontWeight: '600' }}>Contact Everset</h3>
            <p style={{ margin: '4px 0 0', color: 'rgba(255,255,255,0.8)', fontSize: '13px' }}>We'll get back to you within 24 hours</p>
          </div>

          {submitted ? (
            <div style={{ padding: '40px 20px', textAlign: 'center' }}>
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#6B9080" strokeWidth="2" style={{ margin: '0 auto 12px' }}>
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
              </svg>
              <div style={{ fontSize: '16px', fontWeight: '500', color: '#1F2937' }}>Message sent!</div>
              <div style={{ fontSize: '13px', color: '#6B7280', marginTop: '4px' }}>We'll be in touch soon.</div>
            </div>
          ) : (
            <form onSubmit={handleSubmit} style={{ padding: '16px 20px' }}>
              <div style={{ marginBottom: '12px' }}>
                <input
                  type="text" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
                  placeholder="Your name" required
                  style={{ width: '100%', padding: '10px 12px', border: '1px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', outline: 'none' }}
                  onFocus={(e) => e.target.style.borderColor = '#6B9080'}
                  onBlur={(e) => e.target.style.borderColor = '#E5E7EB'}
                />
              </div>
              <div style={{ marginBottom: '12px' }}>
                <input
                  type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                  placeholder="Email address" required
                  style={{ width: '100%', padding: '10px 12px', border: '1px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', outline: 'none' }}
                  onFocus={(e) => e.target.style.borderColor = '#6B9080'}
                  onBlur={(e) => e.target.style.borderColor = '#E5E7EB'}
                />
              </div>
              <div style={{ marginBottom: '16px' }}>
                <textarea
                  value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })}
                  placeholder="How can we help?" required rows={4}
                  style={{ width: '100%', padding: '10px 12px', border: '1px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', outline: 'none', resize: 'vertical', fontFamily: 'inherit' }}
                  onFocus={(e) => e.target.style.borderColor = '#6B9080'}
                  onBlur={(e) => e.target.style.borderColor = '#E5E7EB'}
                />
              </div>
              <button type="submit" disabled={sending}
                style={{
                  width: '100%', padding: '12px', backgroundColor: sending ? '#9CA3AF' : '#6B9080',
                  color: 'white', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '500',
                  cursor: sending ? 'not-allowed' : 'pointer'
                }}>
                {sending ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          )}
        </div>
      )}

      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </>
  );
};

export default SupportWidget;
